import React from 'react'
import PropTypes from 'prop-types'
import './style.scss'
const Title = ({ title }) => {
    return (
        <div className='page-min-title'>{title}</div>
    )
}
Title.propTypes = {
    title: PropTypes.string.isRequired
}
export default Title
